<template>
  <div>
    <v-form
      ref="formDensity"
      v-model="isFormDensityValid"
      lazy-validation>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            lg12>
            <span
              class="caption grey--text font-weight-light">
              {{ $t('Fuel type and density value') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs6
            md3
            lg2>
            <v-select
              v-model="tank.productFamily"
              :items="options.productTypes"
              :label="`${ $t('Product family') }`"
              :disabled="true"
              item-text="desc"
              item-value="code"
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item.code"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  {{ data.item.desc }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs6
            md4
            lg2>
            <v-text-field
              v-model.number="tank.densityCompManual"
              :disabled="features.weightsMeasuresLock"
              :rules="rules.required.concat(rules.density_APIkG)"
              :label="`${ $t('Product density TC') + ' (API - ' + $t('kg/m3') + ')' }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md4
            lg2>
            <v-text-field
              v-if="isDensityfloat"
              v-model.number="tank.measuredDensityTolerance"
              :disabled="features.weightsMeasuresLock"
              :rules="rules.required.concat(rules.tolerance)"
              :label="`${ $t('Tolerance of gravity') + ' (%)'}`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md1
            lg6/>
        </v-layout>
      </v-container>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          v-if="isDensityfloat"
          wrap>
          <v-flex
            xs12
            md12
            lg12>
            <span
              class="caption grey--text font-weight-light">
              {{ $t('Current density values') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs6
            md5>
            <v-text-field
              v-model="densityValues"
              :label="`${ $t('Density (TC density)') + ' (API - ' + $t('kg/m3') + ')' }`"
              disabled
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model="temperatureValue"
              :label="`${ $t('Temperature') + ' (' + options.temperatureUnits.find(c => c.code === systemSettings.temperatureUnit).desc + ')' }`"
              disabled
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md10/>
          <v-expansion-panel
            v-model="coefficientExpanded">
            <v-expansion-panel-content >
              <template v-slot:header>
                <div>{{ $t('Coefficient settings') }}</div>
              </template>
              <v-card>
                <v-card-text>
                  <v-container
                    fill-height
                    fluid
                    grid-list-xl>
                    <v-layout
                      wrap>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="tank.probeDensmeterCoeffA"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.negative)"
                          :label="`${ $t('Coefficient {0}', ['A']) }`"
                          class="dover-input"
                          @change="onCoefficientChange()" />
                      </v-flex>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="tank.probeDensmeterCoeffB"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.positive)"
                          :label="`${ $t('Coefficient {0}', ['B']) }`"
                          class="dover-input"
                          @change="onCoefficientChange()" />
                      </v-flex>
                      <v-flex
                        xs12
                        md6/>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="coefficientDensity"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.density_APIkG_0)"
                          :label="`${ $t('Density') + ' (' + $t('hydrometer') + ')' }`"
                          class="dover-input"
                          @change="onCoeffDensityChange()" />
                      </v-flex>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="coefficientDensityComp"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.density_APIkG_0)"
                          :label="`${ $t('TC Density') + ' (' + $t('hydrometer') + ')' }`"
                          class="dover-input"
                          @change="onCoeffDensityCompChange()" />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-container>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            text-xs-right>
            <v-btn
              :disabled="features.weightsMeasuresLock || !isFormDensityValid"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="saveDensity()">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>

import Vue from 'vue'

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    features: {
      type: Object,
      required: true,
      default: () => {}
    },
    measurement: {
      type: Object,
      required: true,
      default: () => {}
    },
    probeDetected: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isFormDensityValid: true,
    isTankApiDegree: false,
    coefficientExpanded: 0,
    coefficientDensity: 0.0,
    coefficientDensityComp: 0.0,
    coefficientHeight: 0.0,
    coefficientBeta: 1.0,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      tolerance: [ v => Vue.prototype.Maglink.RulesRange(v, 1.0, 100.0) ],
      positive: [ v => Vue.prototype.Maglink.RulesRange(v, 0.0, 10000) ],
      negative: [ v => Vue.prototype.Maglink.RulesRange(v, -1000.0, 0.0) ],
      density_APIkG: [ v => Vue.prototype.Maglink.RulesDoubleRange(v, -3.0, -0.2, 1.5, 1075) ],
      density_APIkG_0: [ v => Vue.prototype.Maglink.RulesRange(v, -3.0, 1075) ]
    }
  }),
  computed: {
    isDensityfloat () {
      return (this.tank.probeDensmeter !== 0)
    },
    densityValues () {
      return this.Maglink.DensityFormat(this.measurement.density) + ' (' + this.Maglink.DensityFormat(this.measurement.densityComp) + ')'
    },
    temperatureValue () {
      return this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(this.measurement.temperature, this.systemSettings.temperatureUnit))
    }
  },
  watch: {
    probeDetected: {
      handler: function (newProbes, oldProbes) {
        this.initCoefficients()
      },
      immediate: true
    }
  },
  mounted () {
    this.isTankApiDegree = this.Maglink.isApiDegree(this.tank.densityCompManual)
    this.initCoefficients()
  },
  methods: {
    initCoefficients () {
      if (this.isDensityfloat) {
        if (Math.abs(this.tank.probeDensmeterCoeffA) < 1.0 && Math.abs(this.tank.probeDensmeterCoeffB) < 1.0) {
          this.probeDetected.forEach(item => {
            if (item.device === 80) {
              var text = this.Maglink.DetectedSerialName(item)
              if (text !== '' && item.serial * 1 === this.tank.serial * 1 && Math.abs(item.coeffA) > 1.0 && Math.abs(item.coeffB) > 1.0) {
                this.tank.probeDensmeterCoeffA = item.coeffA
                this.tank.probeDensmeterCoeffB = item.coeffB
              }
            }
          })
        }
        this.coefficientDensity = this.Maglink.RoundFormat(this.densityToDisplay(this.tank.lastMeasurement.measureDens), 2)
        this.coefficientDensityComp = this.Maglink.RoundFormat(this.densityToDisplay(this.tank.lastMeasurement.measureDensComp), 2)
        this.calculateCoefficientHeight()
        if (this.coefficientDensity > 0.1 && this.coefficientDensityComp > 0.1) {
          this.coefficientBeta = this.Maglink.fromApiDegree(this.tank.lastMeasurement.measureDensComp) / this.Maglink.fromApiDegree(this.tank.lastMeasurement.measureDens)
        }
      }
    },
    calculateCoefficientHeight () {
      if (this.tank.probeDensmeterCoeffA < 0.1 && this.tank.probeDensmeterCoeffB > 0.1) {
        this.coefficientHeight = (this.densityFromDisplay(this.coefficientDensity) - this.tank.probeDensmeterCoeffB) / this.tank.probeDensmeterCoeffA
      }
    },
    onCoefficientChange () {
      if (this.coefficientHeight > 0.0 && this.coefficientDensity > 0.1 && this.coefficientDensityComp > 0.1) {
        var temp = this.tank.probeDensmeterCoeffA * this.coefficientHeight + this.tank.probeDensmeterCoeffB
        this.coefficientDensity = this.Maglink.RoundFormat(this.densityToDisplay(temp), 2)
        this.coefficientDensityComp = this.Maglink.RoundFormat(this.densityToDisplay(temp * this.coefficientBeta), 2)
      } else {
        this.calculateCoefficientHeight()
      }
    },
    onCoeffDensityChange () {
      if (this.coefficientHeight > 0.0 && this.coefficientDensity > 0.1) {
        var temp = this.densityFromDisplay(this.coefficientDensity)
        this.tank.probeDensmeterCoeffB = this.Maglink.RoundFormat(temp - this.tank.probeDensmeterCoeffA * this.coefficientHeight, 3)
        this.coefficientDensityComp = this.Maglink.RoundFormat(this.densityToDisplay(temp * this.coefficientBeta), 2)
      }
    },
    onCoeffDensityCompChange () {
      if (this.coefficientHeight > 0.0 && this.coefficientBeta > 0.0 && this.coefficientDensityComp > 0.1) {
        var temp = this.densityFromDisplay(this.coefficientDensityComp)
        this.coefficientDensity = this.Maglink.RoundFormat(this.densityToDisplay(temp / this.coefficientBeta), 2)
        this.tank.probeDensmeterCoeffB = this.Maglink.RoundFormat((temp / this.coefficientBeta) - this.tank.probeDensmeterCoeffA * this.coefficientHeight, 3)
      }
    },
    densityToDisplay (density) {
      if (this.isTankApiDegree) {
        return this.Maglink.toApiDegree(density)
      }
      return density
    },
    densityFromDisplay (density) {
      return this.Maglink.fromApiDegree(density)
    },
    checkValues () {
      this.isFormDensityValid = true
      if (Math.abs(this.tank.probeDensmeterCoeffA) > 1.0 && Math.abs(this.tank.probeDensmeterCoeffB) < 1.0) {
        this.isFormDensityValid = false
        return this.$t('Invalid coefficient values')
      }
      if (Math.abs(this.tank.probeDensmeterCoeffB) > 1.0 && Math.abs(this.tank.probeDensmeterCoeffA) < 1.0) {
        this.isFormDensityValid = false
        return this.$t('Invalid coefficient values')
      }
      return ''
    },
    saveDensity () {
      if (this.$refs.formDensity.validate()) {
        var msg = this.checkValues()
        if (!this.isFormDensityValid) {
          this.snack('error', msg)
          return
        }
        this.$emit('tankSaved', this.tank.tankNumber)
      } else {
        this.isFormDensityValid = false
      }
    },
    snack (color, message) {
      message = this.$t('Tank density') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
